import { Button } from '@cargoflow/ui/components/button'
import { useNavigate, useRouter } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

type GeneralErrorProps = React.HTMLAttributes<HTMLDivElement> & {
  minimal?: boolean
}

export function GeneralError({ className, minimal = false }: GeneralErrorProps) {
  const navigate = useNavigate()
  const { history } = useRouter()
  return (
    <div className={cn('h-svh w-full', className)}>
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-3 px-4 text-center">
        {!minimal && (
          <span className="font-mono text-sm font-medium tabular-nums text-muted-foreground">
            500
          </span>
        )}
        <h1 className="font-manrope text-3xl font-extrabold tracking-tight sm:text-4xl">
          Something went wrong
        </h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          We apologize for the inconvenience. Please try again later.
        </p>
        {!minimal && (
          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <Button variant="outline" onClick={() => history.go(-1)}>
              Go Back
            </Button>
            <Button onClick={() => navigate({ to: '/' })}>Back to Home</Button>
          </div>
        )}
      </div>
    </div>
  )
}
